import React from 'react';
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';
import { StyledAvatar } from './Avatar.style';

export interface AvatarProps extends Omit<MuiAvatarProps, 'variant'> {
  /**
   * The source URL for the avatar image
   */
  src?: string;
  /**
   * Alternative text for the avatar image
   */
  alt?: string;
  /**
   * The size of the avatar
   */
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  /**
   * The variant of the avatar
   */
  variant?: 'circular' | 'rounded' | 'square';
  /**
   * The color of the avatar background
   */
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'default';
  /**
   * Whether the avatar should have a border
   */
  bordered?: boolean;
  /**
   * Whether the avatar should be clickable
   */
  clickable?: boolean;
  /**
   * Callback fired when the avatar is clicked
   */
  onClick?: () => void;
  /**
   * The content to display inside the avatar (usually initials)
   */
  children?: React.ReactNode;
}

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  size = 'medium',
  variant = 'circular',
  color = 'default',
  bordered = false,
  clickable = false,
  onClick,
  children,
  ...props
}) => {
  return (
    <StyledAvatar
      src={src}
      alt={alt}
      variant={variant}
      size={size}
      color={color}
      bordered={bordered}
      clickable={clickable}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledAvatar>
  );
}; 